import React, { useCallback } from 'react';
import { TrashIcon } from './DesignEditor/icons';
import InlineConfirm from './InlineConfirm';
import css from './AdminSocialPostsPage.css';

// What deleting actually does — the reassurance belongs IN the prompt, because the
// fear it answers ("does this unpublish my post?") is the reason to hesitate.
const DELETE_NOTE =
    'Nur der Workflow-Eintrag wird entfernt. Inserat und bereits veröffentlichte Beiträge bleiben live.';

const DeleteSocialPostButton = ({ postId, onDelete, disabled, disabledReason, className = '' }) => {
    const handleDelete = useCallback(() => (postId ? onDelete(postId) : undefined), [
        postId,
        onDelete,
    ]);

    return (
        <InlineConfirm
            triggerLabel={<TrashIcon size={15} />}
            triggerClassName={`${css.deletePostBtn} ${className}`}
            triggerAriaLabel="Social-Media-Eintrag löschen"
            triggerTitle="Eintrag löschen"
            question="Eintrag löschen?"
            note={DELETE_NOTE}
            confirmLabel="Löschen"
            danger
            disabled={disabled || !postId}
            disabledReason={disabledReason}
            onConfirm={handleDelete}
        />
    );
};

export default DeleteSocialPostButton;
